<template>
  <div class="users-pg">
    <v-container>
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs"/>
      </div>
      <div class="form-npa">
        <div class="position">
          <div class="bg-white p-20">
            <div class="form-head">
              <Widget position="menu_profile"/>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    dark
                    v-on="on"
                    class="navbar-toggler-profile"
                    :aria-label="$t('Открыть меню профиля')"
                  >
                    {{ $t("Профиль") }} <span class="caret" aria-hidden="true"></span>
                  </v-btn>
                </template>
                <v-list class="navbar-collapse">
                  <v-list-item>
                    <Widget position="menu_profile"/>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div class="form-body">
              <router-link
                tag="button"
                class="btn btn-default blue"
                :to="$i18nRoute({ name: 'user_new' })"
              >
                {{ $t('Создать пользователя') }}
              </router-link>
              <div class="search-head">
                <UserSearch
                  v-bind:search="search"
                  v-bind:developers="developers"
                  v-bind:statuses="statuses"
                  @search-user="getDataSearch($event)"
                  @reset-user="resetDataSearch($event)"
                />
              </div>
              <div class="search-result">
                <div class="table-overflow" v-if="users.length">
                  <table>
                    <thead>
                    <tr>
                      <td class="td-id">id</td>
                      <td>
                        <a href="#" :aria-label="$t('Сортировать') + ': ' + $t('email')" @click.prevent="sortData('email')">
                          <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i
                          >{{ $t('email') }}
                        </a>
                      </td>
                      <td>Роли</td>
                      <td>
                        <a href="#" :aria-label="$t('Сортировать') + ': ' + $t('ФИО')" @click.prevent="sortData('fio')">
                          <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i
                          >{{ $t('ФИО') }}
                        </a>
                      </td>
                      <td>
                        <a href="#" :aria-label="$t('Сортировать') + ': ' + $t('Разработчик')" @click.prevent="sortData('developer')">
                          <i class="pro-icon-arrow-bottom1" aria-hidden="true"></i
                          >{{ $t('Разработчик') }}
                        </a>
                      </td>
                      <td>
                        {{ $t('Логин') }}
                      </td>
                      <td>
                        {{ $t('Статус/Координатор') }}
                      </td>
                      <td>
                        {{ $t('Статус/Админ') }}
                      </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="user in users" :key="user.id">
                      <td class="td-id">{{ user.id }}</td>
                      <td>
                        <router-link
                          :title="user.email"
                          :to="$i18nRoute({name: 'user-view', params: { id: user.id }})"
                        >
                          {{ user.email }}
                        </router-link>
                      </td>
                      <td>
                        <template v-for="(roles, i) in user.system_roles">
                          <span :key="roles.id">
                            <span>{{ roles.transName }}</span>
                            <span v-if="i+1 != user.system_roles.length">, </span>
                          </span>
                        </template>
                      </td>
                      <td>{{ user.second_name }} {{ user.first_name }} {{ user.last_name }}</td>
                      <td>
                        <v-icon
                          v-if="user.developer.status === false"
                          class="nv_icon mr-1"
                          x-small
                          aria-hidden="true"
                        />
                        {{ user.developer.transName }}
                      </td>
                      <td>{{ user.nick_name }}</td>
                      <td>{{ user.specialist_access ? $t('Активен') : $t('Не активен') }}</td>
                      <td>{{ user.admin_access ? $t('Активен') : $t('Не активен') }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <div class="total-hint">
                  <p>{{ $t('Общее количество пользователей') }}: {{ usersTotal }}</p>
                </div>
              </div>
            </div>
            <v-pagination
              v-model="page"
              :length="pagesCount"
              :total-visible="10"
              :aria-label="$t('Страницы результатов поиска')"
            />
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
  import Widget from '@/components/app/Widget'
  import UserSearch from '@/components/user/UserSearch'
  import User from '@/model/user'
  import {mapMutations} from 'vuex'
  import { Trans } from "@/plugins/Translation"

  export default {
    components: {
      Widget,
      UserSearch,
    },
    data: () => ({
      users: [],
      developers: [],
      statuses: [],
      search: {},
      page: 1,
      usersTotal: 0,
      pagesCount: 0,
      breadcrumbs: [],
      sortSettings: {
        fio: null,
        email: null,
        developer: null
      }
    }),
    watch: {
      // при изменениях маршрута запрашиваем данные снова
      $route: 'fetchData',
      page() {
        this.searchUser()
      }
    },
    created() {
      this.fetchData()
      this.scrollToTop()
      this.$store.dispatch('fetchCurrentUser')
    },
    methods: {
      ...mapMutations(['setLoading']),
      fetchData() {
        this.setLoading(true)
        this.searchUser()
        this.breadcrumbs = [
          {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
          {text: this.$i18n.t('Управление доступом'), disabled: true}
        ]
        User.getAccessJournalFilterFormData()
          .then((response) => {
            this.developers = response.data.refDeveloper
            this.statuses = [
              { id: true, name: this.$i18n.t('Активен') },
              { id: false, name: this.$i18n.t('Не активен') },
            ]
            this.setLoading(false)
          })
          .catch((error) => {
            this.$router.push(Trans.i18nRoute({
              name: 'error',
              params: {
                status: error.response.status
              }
            }))
            this.setLoading(false)
          })
      },
      //получаем данные с формы поиска
      getDataSearch(search) {
        this.search = {...this.search, ...search}
        this.page = 1
        this.searchUser()
      },
      //очищаем данные с формы поиска
      resetDataSearch() {
        this.search = {}
        this.page = 1
        this.fetchData()
      },
      searchUser() {
        this.setLoading(true)
        this.search.page = this.page
        User.getAccessJournalUserlist(this.search)
          .then((response) => {
            this.users = response.data.items
            const paginator = response.data.paginationData
            this.usersTotal = paginator.totalCount
            this.pagesCount = paginator.pageCount
            this.setLoading(false)
          })
          .catch((error) => {
            this.$router.push(Trans.i18nRoute({
              name: 'error',
              params: {
                status: error.response.status
              }
            }))
            this.setLoading(false)
          })
      },
      //сортировка
      sortData(sortKey) {
        if (
          !this.sortSettings[sortKey] ||
          this.sortSettings[sortKey] === 'desc'
        ) {
          this.sortSettings[sortKey] = 'asc'
        } else {
          this.sortSettings[sortKey] = 'desc'
        }

        this.page = 1
        this.search = {...this.search, ...{page: this.page, orderBy: sortKey, orderDir: this.sortSettings[sortKey]}}
        this.searchUser()
      },
      //прокручиваем на начало страницы
      scrollToTop() {
        window.scrollTo(0, 0)
      }
    }
  }
</script>
